
import Vue from "vue";
import msDataProvider from "../../../services/msDataProvider";
import uiService from "../../../services/uiService";
import { mdiArrowLeft } from "@mdi/js";
import moment from "moment";

export default Vue.extend({
  data() {
    return {
      mdiArrowLeft,
      binding: {},
      canceling: false,
      showDetail: false,
      backendServerName: "",
      time: 0,
      loading: false
    };
  },
  computed: {
    createdTime() {
      try {
        return moment(new Date(this.binding.enrollmentEnrollmentStatus.enrollment_request.created_time * 1000)).format('HH:mm:ss - DD/MM/YYYY');
      } catch (e) {
        return 0;
      }
    }
  },
  methods: {
    async cancel() {
      if (
          await uiService.executeCommand(
              "confirmShow",
              {
                message: this.$t("ENROLLMENT_WAIT.CONFIRM_MESSAGE"),
                title: this.$t("ENROLLMENT_WAIT.CONFIRM_TITLE"),
                cancel: this.$t("ENROLLMENT_WAIT.NO"),
                ok: this.$t("ENROLLMENT_WAIT.YES"),
              },
              true
          )
      ) {
        this.canceling = true;
        await uiService.executeCommand("try", {
          async func() {
            await msDataProvider.executeCommand(
                "enrollmentCancelEnrollmentRequest"
            );
            this.$router.push("prepare").catch((e) => e);
          },
          self: this,
        });
        this.canceling = false;
      }
    },
    async logout() {
      if (
          await uiService.executeCommand(
              "confirmShow",
              {
                message: this.$t("ENROLLMENT_WAIT.LOGOUT_CONFIRM_MESSAGE"),
                title: this.$t("ENROLLMENT_WAIT.LOGOUT_CONFIRM_TITLE"),
                cancel: this.$t("ENROLLMENT_WAIT.CANCEL"),
                ok: this.$t("ENROLLMENT_WAIT.LOGOUT"),
                iconOk: 'icon-logout-white24'
              },
              true
          )
      ) {
        uiService.executeCommand("try", {
          async func() {
            await msDataProvider.executeCommand("authenLogout", {});
            this.$router.push("/prepare").catch((e) => e);
          },
          self: this,
        });
        sessionStorage.removeItem('userId')
      }
    },
  },
  async created() {
    try {
      this.backendServerName = await msDataProvider.executeCommand(
          "backendServerNameGetCurrentValue"
      );
      this.binding.authenAuthenInfo = await msDataProvider.getData("authenAuthenInfo");
    } catch (e) {
      this.error = e;
    }
    msDataProvider.bindDataMany(
        ["enrollmentEnrollmentStatus", "authenAuthenInfo"],
        this.binding,
        this,
        (key, data) => {
          if (key === "enrollmentEnrollmentStatus" && data.fetched) {
            if (sessionStorage.getItem("confirmDeviceSuccess")) {
              this.$router.push("/main");
              return;
            }
            if (data.approved) {
              this.loading = true;
              this.$router.push("/main");
              return;
            }
            if(data.error || data.approved) {
              this.$router.push({name: "enrollment-result"});
            }
          }
        },
        this
    );
  },
  beforeRouteLeave(to, from, next) {
    msDataProvider.unregisterView(this);
    next();
  },
});
